<template>
    <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg12>
            <v-text-field label="Iskalnik" @keyup.esc="search = ''" v-model="search" v-show="!breakPoint" solo append-icon="search"></v-text-field>
                 <v-toolbar  color="white elevation-1">
                    <v-toolbar-title class="subheading">{{ this.settings.title}}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-flex xs4 md4 lg4 v-show="breakPoint">
                            <v-text-field label="Iskalnik" @keyup.esc="search = ''" v-model="search" append-icon="search" single-line></v-text-field>
                        </v-flex>
                        <br>
                        <v-divider
                        class="mx-2"
                        inset
                        vertical
                        ></v-divider>
                        <v-tooltip top v-if="btnToggleColumns">
                            <v-btn slot="activator" fab dark color="blue darken-1" class="datatable_fab_button elevation-1" @click="toggleColumnsMenu">
                                <v-icon class="pointer datatable_action_button" flat icon color="white">menu</v-icon>
                            </v-btn>
                            <span>Filtriraj kolone</span>
                        </v-tooltip>
                        <v-tooltip top v-if="btnRefresh">
                            <v-btn slot="activator" fab dark color="grey darken-1" class="datatable_fab_button elevation-1" @click="refreshDataTable()">
                                <v-icon class="pointer datatable_action_button" flat icon color="white">refresh</v-icon>
                            </v-btn>
                            <span>Osveži podatke</span>
                        </v-tooltip>
                        <v-tooltip top v-if="btnExport">
                            <v-btn slot="activator" fab  dark color="brown darken-1" class="datatable_fab_button elevation-1">
                                <v-icon class="pointer datatable_action_button" flat icon color="white">save_alt</v-icon>
                            </v-btn>
                        <span>Izvozi v Excel</span>
                        </v-tooltip>
                        <v-tooltip v-if="btnAddNew" top>
                            <v-btn slot="activator" fab  dark color="indigo darken-1" class="datatable_fab_button elevation-1" @click="addNewItem()">
                                <v-icon class="pointer datatable_action_button" flat icon color="white">add</v-icon>
                            </v-btn>
                            <span>Dodaj novega uporabnika</span>
                        </v-tooltip>    
                    </v-toolbar>
                <v-data-table :headers="headers" 
                            :items="items" 
                            :pagination.sync="pagination" 
                            :total-items="totalItems" 
                            :loading="loading"
                            :rows-per-page-items="rowsPerPageItems"
                            rows-per-page-text="Prikaz zapisov na stran"
                            class="elevation-1 vps"
                            id="style-11">
                    <v-progress-linear slot="progress"  indeterminate height="4"></v-progress-linear>
                    <template slot="items" slot-scope="props" id="abc">
                    <td v-for="(header, index) in headers" :class="header.class" :key="index">
                        <span v-if="header.text.trim() != 'Upravljanje'">
                            <template v-if="header.visibility">
                                {{ props.item[header.value] }}
                            </template>
                        </span>
                        <span v-else>
                            <!--<v-btn fab small dark color="light-blue darken-1" class="datatable_fab_button elevation-1">-->
                                <v-icon class="pointer datatable_action_button" flat icon color="primary" @click="editItem(props.item)">edit</v-icon>
                            <!--</v-btn>-->&nbsp;&nbsp;&nbsp;
                            <!--<v-btn fab small dark  color="error" class="datatable_fab_button elevation-1">-->
                                <v-icon class="pointer datatable_action_button" flat icon color="error"  @click="deleteItem(props.item)">delete</v-icon>
                            <!--</v-btn>-->
                        </span>
                    </td>
                    </template>
                    <template slot="no-data">
                        <div class="no_data" v-show="!searchQuery">{{ (this.loading) ? "Obdelava podatkov je v teku ..." : "Ni podatkov za prikaz." }}</div>
                        <div class="no_data" v-show="searchQuery">{{ (this.loading) ? 'Obdelava podatkov za iskani niz "'  + this.search + '" je v teku ...' :  `Ni podatkov za iskani niz »${this.search}«.`}}</div>
                    </template>
                    <template slot="pageText" slot-scope="props">
                        Prikazujem {{ props.pageStart }} - {{ props.pageStop }} od {{ props.itemsLength }}
                    </template>
                </v-data-table>
        </v-flex>
        <v-dialog v-model="dialog" persistent max-width="490">
        <v-card>
          <v-card-text>
            <v-icon flat>delete_forever</v-icon>
            {{ dialog_text }}
            </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" flat @click.native="dialogCancel()">Prekliči</v-btn>
            <v-btn :loading="loading" color="primary darken-1" flat @click.native="dialogConfirm()">Nadaljuj</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
</template>

<script>
import { post, get, put, destroy, API_ENDPOINT } from '.././helpers/api'
import { EventBus } from '@/main.js'
export default {
   props: ['settings', 'queryParameters'],
   name: 'data-table',
   components: {
   },
   data: () => ({
       scrollSettings: {},
       search: "",
       totalItems: 0,
       items: [],
       loading: true,
       pagination: {},
       rowsPerPageItems: [5,10,15,25,50,100], 
       interval: null,
       dialog: false,
       dialog_text: '',
       itemToDelete: null,
       loading: false,

        //test
        fav: true,
        menu: true,
        message: false,
        hints: true

   }) ,

   watch: {
       params: {
           handler() {
               this.getDataFromApi()
               .then(data => {
                   this.items = data.items
                   this.totalItems = data.totalItems
               })
               .catch(error => {
                   this.items = [];
                   this.totalItems = 0;
                   console.log(error)
               })
           }
       },

       deep: true
   },

   computed: {
       params(nv) {
           return {
               ...this.pagination,
               query: this.search
           };
       },

       searchQuery() {
           return (this.search != null && this.search.trim() != '') ? true : false;
       },

       btnRefresh() {
           if(this.settings && this.settings.toolbar && this.settings.toolbar.buttons && this.settings.toolbar.buttons.refresh) {
               return true
           }

           return false
       },

       btnExport() {
           if(this.settings && this.settings.toolbar && this.settings.toolbar.buttons && this.settings.toolbar.buttons.export) {
               return true
           }

           return false
       },

       btnAddNew() {
           if(this.settings && this.settings.toolbar && this.settings.toolbar.buttons && this.settings.toolbar.buttons.addNew) {
               return true
           }

           return false
       },

       btnToggleColumns() {
           if(this.settings && this.settings.toolbar && this.settings.toolbar.buttons && this.settings.toolbar.buttons.toggleColumns && 
                this.settings.eventBus && this.settings.eventBus.toggleColumnsId != null && this.settings.eventBus.toggleColumnsId.trim() != ''
           ) {
               return true
           }

           false
       },

       breakPoint() {
           if(this.$vuetify.breakpoint.mdAndUp) {
                return true;
            }

             return false;
       },

       apiParams() {
           let params = {
                ...this.pagination,
                query: this.search,
                columns: this.settings.headers.map(header => {
                    return header.value
                })
            }

            if(this.queryParameters && this.queryParameters != null) {
                let queryParams = this.queryParameters
                params = {
                    ...params,
                    ...queryParams
                }
            }

            //console.log("queryParams")
            //console.log(params)

           return params;
       },

       headers() {
           return this.settings.headers.filter(header => {
               if(header.visibility) {
                   return header
               }
           });
       }
   },

   methods: {
       getDataFromApi() {
           this.loading = true
           
            if(this.settings.hasOwnProperty('eventBus') && this.settings.eventBus.hasOwnProperty('totalItems')) {
                if(this.settings.eventBus.totalItems) {
                    EventBus.$emit(this.settings.eventBus.totalItems.event, {progress: true, value: 0})
                }
            }

            if(this.settings.hasOwnProperty('eventBus') && this.settings.eventBus.hasOwnProperty('sumItems')) {
                if(this.settings.eventBus.sumItems) {
                    EventBus.$emit(this.settings.eventBus.sumItems.event, {progress: true, queryParameters: this.apiParams})
                }
            }

           return new Promise((resolve, reject) => {
               post(API_ENDPOINT + this.settings.endpoint, this.apiParams)
               .then(response => {
                    const {
                    sortBy,
                    descending,
                    page,
                    rowsPerPage
                    } = this.pagination;

                    //this.pagination.rowsPerPage = response.data.meta.per_page
                    //console.log(response)
                    const items = response.data.data
                    const totalItems = response.data.meta.total

                    if(this.settings.hasOwnProperty('eventBus') && this.settings.eventBus.hasOwnProperty('totalItems')) {
                        if(this.settings.eventBus.totalItems) {
                            EventBus.$emit(this.settings.eventBus.totalItems.event, {value: totalItems})
                        }
                    }

                   resolve({items, totalItems})
               })
               .catch(error => {
                   if(this.settings.hasOwnProperty('eventBus') && this.settings.eventBus.hasOwnProperty('totalItems')) {
                        if(this.settings.eventBus.totalItems) {
                            EventBus.$emit(this.settings.eventBus.totalItems.event, {value: 0})
                        }
                    }
                   reject(error)
               })
               .finally(() => {
                   this.loading = false
                   if(this.settings.hasOwnProperty('eventBus') && this.settings.eventBus.hasOwnProperty('totalItems')) {
                        if(this.settings.eventBus.totalItems) {
                            EventBus.$emit(this.settings.eventBus.totalItems.event, {progress: false})
                        }
                    }
               })
           })
       },

       editItem(item) {
           //console.log(item)
           if(this.settings && this.settings.editItem && this.settings.editItem.route) {
               this.$router.push({
                   name: this.settings.editItem.route,
                   params: {
                       id: item.id
                   }
               })
           }

       },

       deleteItem(item) {
           this.itemToDelete = item
           this.dialog_text = 'Ste prepričani da želite odstraniti uporabnika ' + this.itemToDelete.name + '?'
           this.dialog = true

           //console.log(this.itemToDelete)
       },

       dialogConfirm() {
           new Promise( (resolve, reject) => {
               this.loading = true
               /*setTimeout( () =>{
                    this.dialog_confirm = true
                    this.dialog = false
                    this.loading = false

                    this.$store.state.snackbar.display = true
                    this.$store.state.snackbar.text = 'Uporabnik ' + this.itemToDelete.name + ' je bil odstranjen.'

                    this.itemToDelete = null
                    
               },2000)*/
               this.$store.dispatch('DELETE_RFID_USER', this.itemToDelete.id)
               .then(response => {
                    this.dialog = false
                    this.loading = false    
                    this.$store.state.snackbar.mode = ''
                    this.$store.state.snackbar.display = true
                    this.$store.state.snackbar.text = 'Uporabnik ' + this.itemToDelete.name + ' je bil odstranjen.'

                    this.itemToDelete = null
                    this.refreshDataTable()

               })
               .catch(error => {
                    this.dialog = false
                    this.loading = false    
                    this.$store.state.snackbar.mode = 'multi-line'
                    this.$store.state.snackbar.display = true
                    this.$store.state.snackbar.text = 'Pri odstranjevanju uporabnika ' + this.itemToDelete.name + ' je prišlo do napake. Prosimo poskusite ponovno.'
                   this.itemToDelete = null
               })
           })
            
       },

       dialogCancel() {
            this.dialog_confirm = false
            this.dialog = false
            this.itemToDelete = null
       },

       addNewItem() {
           this.$router.push({name: this.settings.toolbar.buttons.addNewRoute})
       },

       refreshDataTable() {
           //console.log("refershing data table...")
           this.getDataFromApi()
            .then(data => {
                this.items = data.items
                this.totalItems = data.totalItems
            })
            .catch(error => {
                this.items = [];
                this.totalItems = 0;
                console.log(error)
            })
       },

        toggleColumnsMenu() {
            if(this.settings && this.settings.toolbar && this.settings.toolbar.buttons && this.settings.toolbar.buttons.toggleColumns && 
                this.settings.eventBus && this.settings.eventBus.toggleColumnsId != null && this.settings.eventBus.toggleColumnsId.trim() != '') {
                    EventBus.$emit(this.settings.eventBus.toggleColumnsId, {
                        toggleColumnsMenu: true
                    });
                }
        }


   },

   mounted() {
        if(this.settings && this.settings.hasOwnProperty('eventBus')) {
            if(this.settings.eventBus.refreshDataTable != null && this.settings.eventBus.refreshDataTable.trim() != '' ) {
                EventBus.$on(this.settings.eventBus.refreshDataTable, (data) => {
                    this.refreshDataTable()
                })
            }

            if(this.settings.eventBus.search != null && this.settings.eventBus.search.trim() != '') {
                EventBus.$on(this.settings.eventBus.search, (data) => {
                    this.search = data
                })
            }
        }  
   },

   created() {
        if(this.settings && this.settings.sortColumn) {
            this.pagination.sortBy = this.settings.sortColumn
        }

        if(this.settings && this.settings.sortDirection && this.settings.sortDirection == 'desc') {
            this.pagination.descending = true
        }

       //if(this.updateInterval) {
        if(this.settings && this.settings.updateInterval) {
            this.interval = setInterval(() => {
                if(this.loading != true) {
                    this.getDataFromApi()
                    .then(data => {
                        this.items = data.items
                        this.totalItems = data.totalItems
                    })
                    .catch(error => {
                        this.items = [];
                        this.totalItems = 0;
                        console.log(error)
                    })
                }
            }, 300000)
       }

       if(this.settings && this.settings.rowsPerPage) {
           this.pagination.rowsPerPage = this.settings.rowsPerPage
       }
   },

   destroyed() {
        clearInterval(this.interval)

        if(this.settings && this.settings.eventBus  && this.settings.eventBus.refreshDataTable) {
            if(this.settings.eventBus.refreshDataTable != null && this.settings.eventBus.refreshDataTable.trim() != '' ) {
                EventBus.$off(this.settings.eventBus.refreshDataTable)
            }
        } 

    }
}
</script>

<style scoped>
    .no_data {
        text-align:center;
    }

    /* scrollbar */
    /**  STYLE 11 */
    #style-11::-webkit-scrollbar {
        width: 10px;
        background-color: #F5F5F5;
    }
    
    #style-11::-webkit-scrollbar-track {
        border-radius: 10px;
        background: rgba(0,0,0,0.1);
        border: 1px solid #ccc;
    }

    #style-11::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background: linear-gradient(left, #fff, #e4e4e4);
        border: 1px solid #aaa;
    }

    #style-11::-webkit-scrollbar-thumb:hover {
        background: #fff;
    }

    #style-11::-webkit-scrollbar-thumb:active {
        background: linear-gradient(left, #22ADD4, #1E98BA);
    }

    .datatable_action_button {
        font-size:20px !important;
    }

    .datatable_fab_button {
        width:32px !important; 
        height:32px !important;
    }

    
</style>


